import { Button } from 'antd';
import { ButtonProps as AntdButtonProps } from 'antd/lib/button';

type ButtonType = 'primary' | 'secondary' | 'default' | 'dark' | 'text' | 'link' | 'white';

export interface ButtonProps extends Omit<AntdButtonProps, 'type'> {
    qa?: string;
    type?: ButtonType;
    outline?: boolean;
}

export default function EnhancedButton({ qa, type, outline, ...props }: ButtonProps) {
    const typeMap: { [key in ButtonType]: string } = {
        default: outline ? 'rl-button-outline' : '',
        primary: outline ? 'rl-button-primary-outline' : 'rl-button-primary',
        secondary: outline ? 'rl-button-secondary-outline' : 'rl-button-secondary',
        dark: outline ? 'rl-button-dark-outline' : 'rl-button-dark',
        text: 'rl-button-text',
        link: 'rl-button-link',
        white: 'rl-button-white'
    };

    const buttonTypeClass = typeMap[type ?? 'default'];
    const buttonClass = buttonTypeClass ? 'rl-button ' + buttonTypeClass : 'rl-button';

    return (
        <Button
            data-qa={qa}
            {...props}
            className={props.className ? `${buttonClass} ${props.className}` : buttonClass}
        />
    );
}
